exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-brand[data-v-bd8951e0]{margin-right:0!important;font-size:1.15em!important}", ""]);

// exports
